var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[(_vm.allTeamUpdates)?_c('div',{staticClass:"container"},_vm._l((_vm.allTeamUpdates.edges),function(post){return _c('Post',{key:post.node.id,attrs:{"post":post}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }